const clearLocalStorage = (keys: string[]): void => {
	keys.forEach((key) => {
		try {
			localStorage.removeItem(key);
		} catch (error) {
			console.error(`Ошибка при удалении ключа "${key}":`, error);
		}
	});
};

export default clearLocalStorage;
